import { apiRequest } from './client';
import type {
  MarkerCatalogEntry,
  MarkerTrend,
  OverviewResponse,
} from './types';

export async function pinMarker(canonicalKey: string, isPriority: boolean): Promise<MarkerCatalogEntry> {
  return apiRequest<MarkerCatalogEntry>(`/markers/${encodeURIComponent(canonicalKey)}/pin`, {
    method: 'POST',
    body: { is_priority: isPriority },
  });
}

export async function getCatalog(): Promise<MarkerCatalogEntry[]> {
  return apiRequest<MarkerCatalogEntry[]>('/markers/catalog');
}

export async function getMarker(canonicalKey: string): Promise<MarkerCatalogEntry> {
  return apiRequest<MarkerCatalogEntry>(`/markers/${encodeURIComponent(canonicalKey)}`);
}

export async function getMarkerHistory(
  canonicalKey: string,
  opts?: { from?: string; to?: string },
): Promise<MarkerTrend> {
  return apiRequest<MarkerTrend>(`/markers/${encodeURIComponent(canonicalKey)}/history`, {
    query: { from: opts?.from, to: opts?.to },
  });
}

export async function getOverview(): Promise<OverviewResponse> {
  return apiRequest<OverviewResponse>('/markers/overview/panels');
}
